// import { INavData } from '@coreui/angular';
type NavAttributes = Record<string, any>;
interface NavWrapper {
  attributes: NavAttributes
  element: string
}
interface NavBadge {
  text: string
  variant: string
}
interface NavLabel {
  class?: string
  variant: string
}

export interface NavData {
  name?: string
  key?: any
  url?: string
  icon?: string
  badge?: NavBadge
  title?: boolean
  version?: string
  children?: NavData[]
  variant?: string
  attributes?: NavAttributes
  divider?: boolean
  class?: string
  label?: NavLabel
  wrapper?: NavWrapper
  UIVersion?: boolean
}
export const navItems: NavData[] = [
  {
    name: 'Custom Dashboard',
    url: '/customDashboard',
    icon: 'fa-solid fa-table-columns',
    key: ['MENU_QUEUE_MONITORING']
  },
  {
    name: 'Starlink',
    url: '/starlink',
    icon: 'fa fa-satellite',
    key: ['MENU_QUEUE_MONITORING']
  },
  {
    name: 'Perimetro AWP',
    url: '/perimetro-awp',
    icon: 'fa  fa-building-shield',
    key: ['MENU_AWP_DASHBOARD_CISCO', 'MENU_AWP_DASHBOARD', 'MENU_NRD_Dashboard']
  },
  {
    name: 'SDWAN Network',
    url: '/sdwan-network',
    icon: 'fa-solid fa-network-wired',
    key: ['MENU_QUEUE_MONITORING', 'SYSADMIN_LOCAL']
  },
  {
    name: 'SpeedTest AWP',
    url: '/speedTest-awp',
    icon: 'fa  fa-building-shield',
    key: ['MENU_SPEEDTEST', 'MENU_SPEEDTEST_CISCO']
  },
   {
    name: 'Mediation AWP',
    url: '/mediation-awp',
    icon: 'fa  fa-building-shield',
    key: ['MENU_QUEUE_MONITORING'],
    children: [
      {
        name: 'Perimetro Sedi',
        url: '/mediation-awp',
        icon: 'fa-solid fa-building-columns',
        key: ['MENU_QUEUE_MONITORING']
      },
      {
        name: 'Run Workflow',
        url: '/mediation-awp/runs',
        icon: 'fa-solid fa-list-check',
        key: ['MENU_QUEUE_MONITORING']
      }
    ]
  },
/* {
        name: 'Report RTU',
        url: '/awpDashboard/report-rtu',
        icon: 'fa-solid fa-chart-simple',
        key: ['MENU_AWP_DASHBOARD_RTU']
  },*/
  {
        name: 'Dashboard RTU',
        url: '/rtu-dashboard',
        icon: 'fa-solid fa-gauge-high',
        key: ['MENU_AWP_DASHBOARD_RTU2']
  },
  {
        name: 'Pianificazioni RTU',
        url: '/awpDashboard/rtu_pianificazioni',
        icon: 'fa-solid fa-calendar-check',
        key: ['MENU_AWP_DASHBOARD_RTU']
  },
  {
    name: 'SDWAN Fortinet',
    url: '/awpDashboard',
    icon: 'fa fa-tower-cell',
    key: ['MENU_AWP_DASHBOARD', 'MENU_AWP_DASHBOARD_ACTIONS', 'MENU_AWP_WORKFLOW_WORKFLOW', 'MENU_AWP_DASHBOARD_CHECK', 'SYSADMIN_LOCAL'],
    children: [
      {
        name: 'Dashboard Fortinet',
        url: '/awpDashboard/dashboard',
        icon: 'fa fa-pie-chart',
        key: ['MENU_AWP_DASHBOARD', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Check Pianificazioni',
        url: '/awpDashboard/checkPianificazioni',
        icon: 'fa fa-check-square',
        key: ['MENU_AWP_DASHBOARD_CHECK', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Actions',
        url: '/awpDashboard/actionsDashboard',
        icon: 'fa fa-tasks',
        key: ['MENU_AWP_DASHBOARD_ACTIONS', 'SYSADMIN_LOCAL']
      },
      {
        name: 'SpeedTest',
        url: '/awpDashboard/speedtest',
        icon: 'fa-solid fa-gauge-high',
        key: ['MENU_SPEEDTEST', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Workflow Fortinet',
        url: '/awpDashboard/wf/awp-workflowFortinet',
        icon: 'fa fa-solid fa-arrows-split-up-and-left',
        key: ['MENU_AWP_WORKFLOW_WORKFLOW', 'OPERATOR', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Pre Staging',
        url: '/awpDashboard/wf/pre-staging',
        icon: 'fa fa-cubes',
        key: ['MENU_AWP_DASHBOARD_CHECK', 'SYSADMIN_LOCAL']
      }
    ]
  },
  {
    name: 'SDWAN Cisco',
    url: '/awpDashboardCisco',
    icon: 'fa fa-tower-cell',
    key: ['MENU_AWP_DASHBOARD_CISCO', 'OPERATOR_CISCO', 'MENU_AWP_DASHBOARD_CISCO_ACTIONS', 'MENU_AWP_DASHBOARD_CISCO_CHECK', 'MENU_AWP_WORKFLOW_CISCO', 'MENU_CISCO_SUMMARY', 'A1_TEMP_PERMISSION', 'SYSADMIN_LOCAL'],
    children: [
      {
        name: 'Dashboard Cisco',
        url: '/awpDashboardCisco/dashboard',
        icon: 'fa fa-pie-chart',
        key: ['MENU_AWP_DASHBOARD_CISCO', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Cisco Summary',
        url: '/awpDashboardCisco/ciscoSummary',
        icon: 'fa fa-desktop',
        key: ['MENU_CISCO_SUMMARY', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Check Pianificazioni',
        url: '/awpDashboardCisco/checkPianificazioni',
        icon: 'fa fa-check-square',
        key: ['MENU_AWP_DASHBOARD_CISCO_CHECK', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Actions',
        url: '/awpDashboardCisco/actionsDashboard',
        icon: 'fa fa-tasks',
        key: ['MENU_AWP_DASHBOARD_CISCO_ACTIONS', 'SYSADMIN_LOCAL']
      },
      {
        name: 'SpeedTest',
        url: '/awpDashboardCisco/speedtest',
        icon: 'fa-solid fa-gauge-high',
        key: ['MENU_SPEEDTEST_CISCO', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Workflow Cisco',
        url: '/awpDashboardCisco/wf/awp-workflowCisco',
        icon: 'fa fa-solid fa-arrows-split-up-and-left',
        key: ['MENU_AWP_WORKFLOW_CISCO', 'OPERATOR_CISCO', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Perimetro A1',
        url: '/awpDashboardCisco/perimetroA1',
        icon: 'fa-solid fa-person-digging',
        key: ['A1_TEMP_PERMISSION', 'SYSADMIN_LOCAL']
      }
    ]
  },
  {
    name: 'NRD',
    url: '/NRD',
    icon: 'fa-solid fa-globe',
    key: ['MENU_NRD_Migrazioni', 'MENU_NRD_Dashboard', 'SYSADMIN_LOCAL'],
    children: [
      {
        name: 'NRD Dashboard',
        url: '/NRD/NRD-dashboard',
        icon: 'fa-solid fa-square-poll-vertical',
        key: ['MENU_NRD_Dashboard', 'SYSADMIN_LOCAL']
      },
      {
        name: 'NRD Migrazioni',
        url: '/NRD/NRD-migrazioni',
        icon: 'fa-solid fa-shuffle',
        key: ['MENU_NRD_Migrazioni', 'SYSADMIN_LOCAL']
      },
      {
        name: 'NRD Migrazioni v2',
        url: '/NRD/NRD-migrazioni-v2',
        icon: 'fa-solid fa-shuffle',
        key: ['MENU_NRD_Migrazioni', 'SYSADMIN_LOCAL']
      },
      {
        name: 'NRD Cessazioni',
        url: '/NRD/NRD-cessazioni',
        icon: 'fa-solid fa-phone-slash',
        key: ['MENU_NRD_Cessazioni', 'SYSADMIN_LOCAL']
      }
    ]
  },
  {
    name: 'VOIP',
    url: '/voip',
    icon: 'fa fa-solid fa-phone-volume',
    key: ['MENU_VOIP', 'SYSADMIN_LOCAL'],
    children: [
      {
        name: 'Voip Dashboard',
        url: '/voip/voip-dashboard',
        icon: 'fa fa-solid fa-pie-chart',
        key: ['MENU_VOIP_DASHBOARD', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Voip Workflow',
        url: '/voip/voip-workflow',
        icon: 'fa fa-solid fa-diagram-successor',
        key: ['MENU_VOIP_WORKFLOW', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Voip Linee',
        url: '/voip/voip-linee',
        icon: 'fa fa-duotone fa-house-laptop',
        key: ['MENU_VOIP_SEDI', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Voip Raker',
        url: '/voip/voip-raker',
        icon: 'fa fa-solid fa-upload',
        key: ['MENU_VOIP_RAKER', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Voip Flussi',
        url: '/voip/voip-flussi',
        icon: 'fa fa-solid fa-folder-tree',
        key: ['MENU_VOIP_FLUSSI', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Voip Gantt',
        url: '/voip/voip-gantt',
        icon: 'fa fa-solid fa-folder-tree',
        key: ['MENU_VOIP_GANTT', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Voip Fax Server',
        url: '/voip/voip-faxserver',
        icon: 'fa fa-solid fa-fax',
        key: ['MENU_VOIP_FAXSERVER', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Voip Sonde 2N',
        url: '/voip/voip-sonde2N',
        icon: 'fa fa-solid fa-hard-drive',
        key: ['MENU_VOIP_2N', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Voip Linee SPOT',
        url: '/voip/voip-lineeSpot',
        icon: 'fa fa-solid fa-bell-concierge',
        key: ['MENU_VOIP_LINEE_SPOT', 'SYSADMIN_LOCAL']
      }
    ]
  },
  {
    name: 'VOIP Fastweb',
    url: '/voipfastweb',
    icon: 'fa-solid fa-square-phone',
    key: ['MENU_VOIP_FASTWEB', 'SYSADMIN_LOCAL'],
    children: [
      {
        name: 'Dashboard NP',
        url: '/voipfastweb/voip-dashboardNPFastweb',
        icon: 'fa-solid fa-chart-gantt',
        key: ['MENU_VOIP_DASHBOARD_NPFASTWEB', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Perimetro NP',
        url: '/voipfastweb/voip-NPFastweb',
        icon: 'fa-solid fa-phone-volume',
        key: ['MENU_VOIP_NPFASTWEB', 'SYSADMIN_LOCAL']
      }
    ]
  },
  {
    name: 'Raker',
    url: '/raker',
    icon: 'fa fa-server',
    key: ['MENU_RAKER', 'SYSADMIN_LOCAL'],
    children: [
      /* {
        name: 'Dashboard',
        url: '/raker/dashboard',
        icon: 'fa fa-list-alt',
        key: ['MENU_RAKER_DASHBOARD', 'SYSADMIN_LOCAL']
      }, */ {
        name: 'Main',
        url: '/raker/main',
        icon: 'fa fa-database',
        key: ['MENU_RAKER_MAIN', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Schedule',
        url: '/raker/schedule',
        icon: 'fa fa-calendar',
        key: ['MENU_RAKER_SCHEDULER', 'SYSADMIN_LOCAL']
      }
    ]
  },
  /* {
    key: 'alwaysShow',
    divider: true
  }, */
  {
    name: 'Administration',
    url: '/admin',
    icon: 'fa fa-solid fa-screwdriver-wrench',
    key: ['MENU_ADMINISTRATION', 'SYSADMIN_LOCAL'],
    children: [
      {
        name: 'FuseqFlow',
        url: '/fuseqflow/flowchart',
        icon: 'fa fa-gear',
        key: ['SYSADMIN_LOCAL']
      },
      {
        name: 'Configurations',
        url: '/admin/systemConfiguration',
        icon: 'fa fa-gear',
        key: ['MENU_ADMINISTRATION_CONFIGURATIONS', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Maintenance',
        url: '/admin/maintenance',
        icon: 'fa-solid fa-triangle-exclamation',
        key: ['MENU_ADMINISTRATION_CONFIGURATIONS', 'SYSADMIN_LOCAL']
      }, {
        name: 'Support',
        url: '/support/manage',
        icon: 'fa-solid fa-circle-info',
        key: ['SUPPORT_MANAGE', 'SYSADMIN_LOCAL']
      }, {
        name: 'Raiden Configurations',
        url: '/admin/raidenConfiguration',
        icon: 'fa fa-gear',
        key: ['MENU_SYSTEM_MONITOR']
      },
      {
        name: 'Classes',
        url: '/admin/classManager',
        icon: 'fa fa-columns',
        key: ['MENU_ADMINISTRATION_CLASSES', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Lookup',
        url: '/admin/lookupManager',
        icon: 'fa fa-list-alt',
        key: ['MENU_ADMINISTRATION_LOOKUP', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Catalog',
        url: '/admin/catalog',
        icon: 'fa fa-th',
        key: ['MENU_ADMINISTRATION_CATALOG', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Catalog v2',
        url: '/admin/catalogv2',
        icon: 'fa fa-th',
        key: ['MENU_ADMINISTRATION_CATALOG', 'SYSADMIN_LOCAL']
      }
    ]
  },
  {
    name: 'Profiling',
    url: '/profiling',
    icon: 'fa fa-solid fa-users-gear',
    key: ['MENU_PROFILING', 'SYSADMIN_LOCAL'],
    children: [
      {
        name: 'Permissions',
        url: '/profiling/permissions',
        icon: 'fa fa-solid fa-user-shield',
        key: ['MENU_PROFILING_PERMISSIONS', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Users',
        url: '/profiling/users',
        icon: 'fa fa-users',
        key: ['MENU_PROFILING_USERS', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Roles',
        url: '/profiling/roles',
        icon: 'fa fa-solid fa-users-viewfinder',
        key: ['MENU_PROFILING_PERMISSIONS', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Groups',
        url: '/profiling/groups',
        icon: 'fa fa-solid fa-building-user',
        key: ['MENU_PROFILING_GROUPS', 'SYSADMIN_LOCAL']
      }
    ]
  },
  {
    name: 'AWP Workflow',
    url: '/awpWorkflow',
    icon: 'fa fa-solid fa-network-wired',
    key: ['MENU_AWP_WORKFLOW', 'OPERATOR', 'SYSADMIN_LOCAL'],
    children: [
      {
        name: 'Configuration',
        url: '/awpWorkflow/awp-configuration',
        icon: 'fa fa-solid fa-gears',
        key: ['MENU_AWP_WORKFLOW_CONFIGURATION', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Template',
        url: '/awpWorkflow/awp-template',
        icon: 'fa fa-solid fa-timeline',
        key: ['MENU_AWP_WORKFLOW_TEMPLATE', 'SYSADMIN_LOCAL']
      }
    ]
  },
  {
    name: 'AWP',
    url: '/awp',
    icon: 'fa-regular fa-folder-open',
    key: ['MENU_AWP_TOTEM', 'MENU_QUEUE_MONITORING', 'MENU_SPEEDTEST_POOL', 'SYSADMIN_LOCAL'],
    children: [
      {
        name: 'Totem',
        url: '/awp/awp-totem',
        icon: 'fa fa-solid fa-arrows-split-up-and-left',
        key: ['MENU_AWP_TOTEM', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Queue Monitoring',
        url: '/awp/queue-monitoring',
        icon: 'fa-solid fa-table-list',
        key: ['MENU_QUEUE_MONITORING', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Sedi',
        url: '/awp/sites',
        icon: 'fa-solid fa-location-dot',
        key: ['MENU_QUEUE_MONITORING', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Variazioni Anagrafica',
        url: '/awp/siti-anagrafica-changes',
        icon: 'fa-solid fa-code-compare',
        key: ['MENU_QUEUE_MONITORING', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Voip Monitoring',
        url: '/awp/voip-monitoring',
        icon: 'fa-solid fa-clipboard-check',
        key: ['MENU_QUEUE_MONITORING', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Voip Check',
        url: '/awp/voip-check',
        icon: 'fa-solid fa-list-check',
        key: ['MENU_QUEUE_MONITORING', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Speedtest Pool',
        url: '/awp/speedtest-pool',
        icon: 'fa-regular fa-rectangle-list',
        key: ['MENU_QUEUE_MONITORING', 'SYSADMIN_LOCAL']
      },
      {
        name: 'System Cron',
        url: '/awp/systemCron',
        icon: 'fa-regular fa-calendar-days',
        key: ['MENU_QUEUE_MONITORING', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Analisi SIM',
        url: '/awp/sim-analysis',
        icon: 'fa-solid fa-sim-card',
        key: ['MENU_QUEUE_MONITORING', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Configurazioni Cisco',
        url: '/awp/cisco-fabric',
        icon: 'fa-solid fa-network-wired',
        key: ['MENU_QUEUE_MONITORING', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Sharepoint',
        url: '/awp/sharepoint',
        icon: 'fa-solid fa-file-excel',
        key: ['MENU_QUEUE_MONITORING', 'SYSADMIN_LOCAL']
      },
      {
        name: 'Node Monitor',
        url: '/awp/node-monitor',
        icon: 'fa fa-solid fa-server',
        key: ['MENU_QUEUE_MONITORING', 'SYSADMIN_LOCAL']
      }
    ]
  },
  {
    name: 'Catalog',
    url: '/catalog',
    icon: 'fa fa-solid fa-box-open',
    key: ['MENU_ADMINISTRATION_CATALOG', 'SYSADMIN_LOCAL'],
    children: [
    ]
  },
  {
    name: 'Catalog V2',
    url: '/catalogv2',
    icon: 'fa fa-solid fa-box-open',
    key: ['MENU_ADMINISTRATION_CATALOG_V2', 'SYSADMIN_LOCAL'],
    children: [
    ]
  },
  {
    name: 'System Monitor',
    url: '/systemMonitor/dashboard',
    icon: 'fa fa-bar-chart',
    key: ['MENU_SYSTEM_MONITOR', 'SYSADMIN_LOCAL']
  }
  /* {
    name: 'Dashboard',
    url: '/dashboard/dashboard',
    icon: 'fa fa-pie-chart',
    key: ['MENU_SYSTEM_MONITOR', 'SYSADMIN_LOCAL']
  } */
]
